var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAuth0White = function SvgAuth0White(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m15.29 16.18-2.017-6.188 5.287-3.807h-6.54L9.997.004V.002h6.54l2.023 6.182.001-.001a8.92 8.92 0 0 1-3.27 9.999zm-10.58 0h-.002l5.29 3.822 5.292-3.82L10 12.361zM1.442 6.182c-1.235 3.78.2 7.784 3.268 9.999v-.003l2.021-6.178-5.286-3.817H7.98L10 .004h.002-6.54z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAuth0White);
export { ForwardRef as ReactComponent };